var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    "+_vm._s(_vm._f("date")(_vm.insertion.advertisingSpace.broadcastStartDate))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }